<template>
  <!-- 公告组件库 -->
  <div class="notice" style="position: relative">
    <div v-if="!isShow" :class="{ mask: !isShow }">已隐藏</div>
    <!-- 组件库左侧名称 -->
    <slot name="name" />
    <!-- 公告 -->
    <van-notice-bar
      class="fontFamily"
      @click="handleClickHttp"
      :text="datas.noticeText"
      left-icon="volume-o"
      :background="datas.backColor"
      :color="datas.textColor"
      mode="link"
    >
      <!-- 核心：left-icon 具名插槽，专门替换左侧图标 -->
      <template #left-icon>
        <i
          v-if="datas.image.includes('iconfont')"
          :class="datas.image"
          style="font-size: 28px"
        ></i>
        <van-icon
          :name="datas.image ? datas.image : $imagePath.noticeImage1"
          size="28px"
        />
      </template>
    </van-notice-bar>
    <!-- 删除组件 -->
    <slot name="deles" />
  </div>
</template>

<script>
export default {
  name: "notice",
  props: {
    datas: Object,
    isShow: Boolean,
  },
  created() {
    console.log("通知公告子组件挂载了-------------------------", this.datas);
  },
  methods: {
    // 处理点击事件
    handleClickHttp() {
      // 触发自定义事件，通知父组件
      this.$emit("navigation-click", this.datas);
    },
  },
};
</script>

<style scoped lang="scss">
// 覆盖vant通知栏字体样式
::v-deep.van-notice-bar.fontFamily {
  .van-notice-bar__wrap {
    .van-notice-bar__content {
      font-family: v-bind("datas.fontFamily");
    }
  }
}
:deep(.custom-notice-text .van-notice-bar__content) {
  font-size: 30px !important; /* 自定义字号，按需改 12/13/14px 都可以 */
  line-height: 20px; /* 可选：搭配字号调整行高，让垂直居中更舒服，推荐加 */
}
.notice {
  position: relative;
}
</style>
